import { Component } from 'react';

// can't figure out why proptype warnings are being thrown when the prop types are correct
// typeof this.props.children === 'function'
// typeof this.props.load === 'function'
// ...but it still complains about invalid prop types

class Bundle extends Component {
    state = {
        asyncModule: null
    };

    UNSAFE_componentWillMount() {//eslint-disable-line
        this.load( this.props );
    }

    UNSAFE_componentWillReceiveProps( nextProps ) {//eslint-disable-line
        if ( nextProps.load !== this.props.load ) {
            this.load( nextProps );
        }
    }

    load( props ) {
        this.setState( {
            asyncModule: null
        } );

        props.load( ( asyncModule ) => {
            this.setState( {
                // handle both es imports and cjs
                asyncModule: asyncModule.default ? asyncModule.default : asyncModule
            } );
        } );
    }

    render() {
        return this.props.children( this.state.asyncModule );
    }
}

export default Bundle;
